// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22I8P","label":"styles_label__YgWY9"};